module.exports = __webpack_public_path__ + "img/banner_kemoclub.f3c54c78.png";